import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import { Icon, RowView } from "../../../../Component/style/common_style";
import { useNavigate } from "react-router-dom";
import { amountFormat } from "../../../../Component/tool/Tools";
import React, { useState } from "react";
import CheckModal from "./CheckModal";
import api from "../../../../Component/axios_Interceptor/api";
import url from "../../../../Component/server";

interface CoinChargeModalProps extends modalProps {
  myCoin: number;
  handleReload: () => void;
}

const CoinChargeModal = ({
  visible,
  handleModal,
  myCoin,
  handleReload,
}: CoinChargeModalProps) => {
  const Navigate = useNavigate();
  const goHome = () => Navigate("/");

  const [chargeCoin, setChargeCoin] = useState(500);
  const handleChargeCoin = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChargeCoin(Number(e.target.value));
  };
  const [select, setSelect] = useState(0);

  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const [checkVisible, setCheckVisible] = useState(false);
  const handleCheckModal = () => {
    setCheckVisible(!checkVisible);
  };

  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          코인 충전
          <Icon
            className="btn"
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title>
        <MyCoinDiv>
          보유 코인
          <div className="blue">{amountFormat(myCoin)}C</div>
        </MyCoinDiv>
        <Title style={{ marginTop: 40 }}>충전 코인</Title>
        <RowView style={{ marginTop: 16, gap: 8 }}>
          <SelectDiv
            $select={select === 0}
            onClick={() => {
              setChargeCoin(500);
              setSelect(0);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 0
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              500C
            </RowView>
            50,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 1}
            onClick={() => {
              setChargeCoin(1000);
              setSelect(1);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 1
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              1,000C
            </RowView>
            100,000원
          </SelectDiv>
        </RowView>
        <RowView style={{ marginTop: 16, gap: 8 }}>
          <SelectDiv
            $select={select === 2}
            onClick={() => {
              setChargeCoin(2000);
              setSelect(2);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 2
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              2,000C
            </RowView>
            200,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 3}
            onClick={() => {
              setChargeCoin(3000);
              setSelect(3);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 3
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              3,000C
            </RowView>
            300,000원
          </SelectDiv>
        </RowView>
        <RowView style={{ marginTop: 16, gap: 8 }}>
          <SelectDiv
            $select={select === 4}
            onClick={() => {
              setChargeCoin(4000);
              setSelect(4);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 4
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              4,000C
            </RowView>
            400,000원
          </SelectDiv>
          <SelectDiv
            $select={select === 5}
            onClick={() => {
              setChargeCoin(5000);
              setSelect(5);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 5
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              5,000C
            </RowView>
            500,000원
          </SelectDiv>
        </RowView>
        <RowView style={{ marginTop: 16, gap: 8 }}>
          <SelectDiv
            $select={select === 6}
            onClick={() => {
              setChargeCoin(0);
              setSelect(6);
            }}
          >
            <RowView
              style={{
                fontSize: 16,
                fontFamily: "var(--font-Pretendard-Regular)",
              }}
            >
              <Icon
                src={
                  select === 6
                    ? require("../../../../Image/ic_check_on.png")
                    : require("../../../../Image/ic_check_off.png")
                }
                style={{ marginRight: 8 }}
              />
              직접입력
            </RowView>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                fontSize: 18,
                width: "50%",
              }}
            >
              <CoinInput
                type="number"
                value={select === 6 ? chargeCoin : 0}
                style={{ color: select !== 6 ? "#c6c6c6" : "black" }}
                disabled={select !== 6}
                onChange={handleChargeCoin}
              />
              C
            </div>
          </SelectDiv>
          <SelectDiv $select={false} style={{ border: "0" }} />
        </RowView>
        <NoticeDiv>
          <div className="title">요금 안내</div>
          <div>
            • 시청자 수 100명에 1시간 방송시 약 381코인(38,020원)이 소모됩니다.
          </div>
          <div style={{ marginTop: 8 }}>
            • 방송예약 요금은 환율에 따라 변동될 수 있습니다.
          </div>
        </NoticeDiv>
        <PriceDiv>
          결제 금액
          <div className="price">{amountFormat(chargeCoin * 100)}원</div>
        </PriceDiv>
        <BtnDiv>
          <ApplyBtn disabled={chargeCoin <= 0} onClick={handleCheckModal}>
            충전하기
          </ApplyBtn>
        </BtnDiv>
      </ModalBox>
      <CheckModal
        visible={checkVisible}
        handleModal={handleCheckModal}
        chargeCoin={chargeCoin}
        myCoin={myCoin}
        handleCharge={closeModal}
        handleReload={handleReload}
      />
    </Container>
  );
};
export default CoinChargeModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 90%;
  max-width: 45rem;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 34px 24px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
  margin-top: 40px;
`;

const Btn = styled.button`
  border: 0;
  border-radius: 8px;
  height: 44px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: ${(props) =>
    props.disabled ? "#8e8e8e" : "linear-gradient(135deg, #7955f0, #3209b9)"};

  color: white;
`;

const MyCoinDiv = styled.div`
  padding: 22px 24px;
  margin-top: 24px;
  border-radius: 8px;
  background-color: #ede8ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  .blue {
    color: #3209b9;
    font-family: var(--font-Pretendard-SemiBold);
    font-size: 22px;
  }
`;

const SelectDiv = styled.div<{ $select: boolean }>`
  border-radius: 8px;
  border: 1px solid;
  border-color: ${(props) => (props.$select ? "#3209B9" : "#f0f0f0")};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  display: flex;
  padding: 24px;
  width: 100%;
  cursor: pointer;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const CoinInput = styled.input`
  border: none;
  outline: none;
  text-align: right;
  color: black;
  font-size: 18px;
  width: 50%;
  background-color: white;
  /* 화살표 제거 - Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

const NoticeDiv = styled.div`
  padding: 30px 0px;
  border-bottom: 1px solid #f0f0f0;
  .title {
    font-family: var(--font-Pretendard-SemiBold);
    color: black;
    margin-bottom: 16px;
  }
  color: #8e8e8e;
`;

const PriceDiv = styled(RowView)`
  font-family: var(--font-Pretendard-Medium);
  .price {
    font-family: var(--font-Pretendard-SemiBold);
    font-size: 22px;
    color: #eb003b;
  }
  margin-top: 30px;
`;
